import { render } from "./CarucelNoticias.vue?vue&type=template&id=6f7962e0&scoped=true"
import script from "./CarucelNoticias.vue?vue&type=script&lang=js"
export * from "./CarucelNoticias.vue?vue&type=script&lang=js"

import "./CarucelNoticias.vue?vue&type=style&index=0&id=6f7962e0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7962e0"]])

export default __exports__